import { Badge, Callout, Card, Flex, Tabs, Text } from "@radix-ui/themes";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AlertNotification } from "../../../components/common/Notifications";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetStudentDebtNotificationsQuery } from "../../../hooks/useGetStudentDebtNotificationsQuery ";
import { useGetTeacheIdByUserId } from "../../../hooks/useGetTeacheIdByUserId";
import { RootState } from "../../../redux/store";
import { routes } from "../../../routes";
import { updateStudentDebtNotification } from "../../../services/finance/studentDebtNotification";
import { Key_studentDebtNotifications } from "../../../utils/constants";
type ActiveSegmentTab = 'viewed' | 'not_viewed';

export const StudentDebtNotifications = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const [activeSegment, setActiveSegment] = useState<ActiveSegmentTab>('not_viewed');
    const { UserId } = useSelector((state: RootState) => state.login.userData);
    const { data: studentData, isLoading: isLoadingStudentData } = useGetTeacheIdByUserId(UserId);
    const mutationUpdateStudentDebtNotification = useMutation({ mutationFn: updateStudentDebtNotification, mutationKey: "updateStudentDebtNotification" });
    const { data: studentDebtsNotificationsData, refetch: fetchStudentDebts, status: studentDebtsStatus } = useGetStudentDebtNotificationsQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.idStudent },
        {
            enabled: !!studentData?.idStudent
        }
    )
    //const studentDebtsNotificationsData = { items: studentDebtNotifications };
    const viewed = studentDebtsNotificationsData?.items.filter(s => s.isViewed)
    const not_viewed = studentDebtsNotificationsData?.items.filter(s => !s.isViewed)
    const navigateAndValidate = (tabToNavigateTo: ActiveSegmentTab) => {
        if (activeSegment !== tabToNavigateTo) setActiveSegment(tabToNavigateTo);
    }
    const handleMarkAsRead = async (id: string) => {
        try {
            const notification = studentDebtsNotificationsData?.items.find(i => i.id === id);
            if (notification) {
                notification.isViewed = true;
                await mutationUpdateStudentDebtNotification.mutateAsync(notification);
                toast.success("Marcada como lida");
                queryClient.invalidateQueries(Key_studentDebtNotifications);
            }
        } catch (error) {
            toast.error("Ops ocorreu um erro!");
        }
    };

    if (!studentData || !studentData.idStudent) {
        return (
            <Flex direction="column">
                <Callout.Root color="red" role="alert">
                    <Text>
                        Entre como estudante &nbsp;
                        <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
                    </Text>
                </Callout.Root>

            </Flex>
        );
    }

    return (
        <Card size='1'>
            <Flex direction='column' gap='4'>
                <Tabs.Root value={activeSegment}
                    onValueChange={(tabToNavigate) => {
                        navigateAndValidate(tabToNavigate as ActiveSegmentTab);
                    }}
                >
                    <Tabs.List>
                        <Tabs.Trigger value="not_viewed">Novas
                            {not_viewed && not_viewed.length > 0 ? <>
                                <Badge color="red">
                                    {not_viewed.length}
                                </Badge>
                            </> : <></>}
                        </Tabs.Trigger>
                        <Tabs.Trigger value="viewed">Lidas</Tabs.Trigger>
                    </Tabs.List>
                    <Tabs.Content value="not_viewed">
                        <Flex direction='column' gap='3' style={{ padding: '1%' }}>
                            {not_viewed?.map((notification) => (
                                <AlertNotification
                                    key={notification.id}
                                    id={notification.id!}
                                    message={notification.message}
                                    isViewed={notification.isViewed}
                                    onMarkAsRead={handleMarkAsRead}
                                />
                            ))}
                        </Flex>
                    </Tabs.Content>
                    <Tabs.Content value="viewed">
                        <Flex direction='column' gap='3' style={{ padding: '1%' }}>

                            {viewed?.map((notification) => (
                                <AlertNotification
                                    key={notification.id}
                                    id={notification.id!}
                                    message={notification.message}
                                    isViewed={notification.isViewed}
                                    onMarkAsRead={handleMarkAsRead}
                                />
                            ))}
                        </Flex>

                    </Tabs.Content>
                </Tabs.Root>
            </Flex>
        </Card>
    )
}
